import React from 'react'

import { Link } from 'gatsby'
import { FooterType } from '../../types'
import useMinimalConfig from "../../hooks/use-minimal-config"
import useSiteMetadata from "../../hooks/use-site-metadata"
import replaceSlashes from '../../../utils/replace-slashes'

type Props = {
  footer: FooterType,
  [key: string]: any
}

const FooterTwoSections = ({footer, ...props}: Props) => {
  const { footerNavigation: nav, basePath } = useMinimalConfig()
  const { footerCopyrightText, footerTopText } = useSiteMetadata()

  return (
    <footer className='mx-auto text-center font-mont font-medium overflow-x-hidden'>
      <div id="footer-bg-white" className='text-footerV3 py-10 md:pt-16 md:pb-24 px-4 sm:px-6 lg:px-0'>
        {!footer?.advanced?.hideFooterTopText && (
          <p className="mb-10 md:mb-20 text-3xl md:text-4.5xl font-extrabold">{footerTopText}</p>
        )}
        {nav &&
          nav.map((item) => (
            <Link key={item.slug} className="block text-xl md:w-max m-auto" to={replaceSlashes(`/${basePath}/ppc-b/${item.slug}`)}>
              {item.title}
            </Link>
          ))}
      </div>
      {footerCopyrightText && (
        <div id="footer-bg-blue" className="text-white bg-footerV3">
          <div className="mx-auto max-w-screen-lg text-center text-xs md:text-lg py-10 md:py-20 px-4 sm:px-6 xl:px-0">
            {/*footerCopyrightText*/}
            UNITE HEALTH SHARE MINISTRIES (UHSM), IS A RELIGIOUS ORGANIZATION FACILITATING THE SHARING OF MEDICAL EXPENSES. IT IS NOT AN INSURANCE COMPANY, AND NEITHER ITS GUIDELINES OR ITS PLAN OF OPERATION, OR ANY OTHER DOCUMENTS OF THE RELIGIOUS ORGANIZATION CONSTITUTE OR CREATE AN INSURANCE POLICY. MEMBERSHIP IS NOT OFFERED THROUGH AN INSURANCE COMPANY, AND THE ORGANIZATION IS NOT SUBJECT TO THE REGULATORY REQUIREMENTS OR CONSUMER PROTECTIONS OF ANY STATE’S INSURANCE CODE. THE SHARING PROGRAMS, SERVICES, PUBLICATIONS, AND ANY MATERIALS GIVEN SHOULD NEVER BE CONSIDERED A SUBSTITUTE FOR AN INSURANCE POLICY.
          </div>
        </div>
      )}
    </footer>
  )
}

export default FooterTwoSections